import { ReactNode, useState } from 'react'

import randomColor from 'randomcolor'

import { LeadContext, INITIAL_STATE, LeadState } from './leadContext'

import { PostLeadResponse, LeadVariant, Lead } from 'modules/lead/types'
import useLeadDataState from 'modules/lead/hooks/useLeadDataState'

interface Props {
  children: ReactNode,
  state?: LeadState
}

const color = randomColor({ luminosity: 'dark' })

export const LeadProvider = ({ children, state }: Props) => {
  const [isLoading, setIsLoading] = useState(INITIAL_STATE.postLead.isLoading)
  const [response, setResponse] = useState<PostLeadResponse>(INITIAL_STATE.postLead.response)
  const [hasError, setHasError] = useState(INITIAL_STATE.postLead.hasError)

  const [leadVariant, setLeadVariant] = useState<LeadVariant | null>(INITIAL_STATE.leadVariant)

  const leadData = useLeadDataState()

  const lead: Lead = {
    email: leadData.data.email,
    name: leadData.data.name,
    schedule: leadData.data.schedule,
    photo: leadData.data.photo,
    color,
    accepted: leadData.data.accepted,
    userPlatformId: leadData.data.userPlatformId,
    contactId: response.contactId,
    sparkieUserId: (
      leadData.data.userPlatformId || (response.contactId && `user_guest_${response.contactId}`) || ''
    ).toString()
  }

  return (
    <LeadContext.Provider value={{
      lead,
      leadVariant,
      setLeadVariant,
      postLead: {
        isLoading,
        setIsLoading,
        response,
        setResponse,
        hasError,
        setHasError
      },
      leadData,
      ...state
    }}>
      {children}
    </LeadContext.Provider>
  )
}
